export default {
  id: null,
  descricao: null,
  itens: [],
  empresaID: null,
  tipo: 0,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/reportmodel.js